// src/services/usuariosTrsService.js
import axios from "../config/axiosConfig";

export const listUsuariosTrs = (params = {}) => axios.get("/api/usuarios-trs", { params });

export const createUsuarioTrs = (payload) => axios.post("/api/usuarios-trs", payload);

export const updateUsuarioTrs = (id, cambios) => axios.patch(`/api/usuarios-trs/${id}`, cambios);

export const resetPasswordUsuarioTrs = (id, newPassword) =>
  axios.patch(`/api/usuarios-trs/${id}/password`, { newPassword });

export const uploadFotoUsuarioTrs = (id, file) => {
  const formData = new FormData();
  formData.append("profilePicture", file);
  return axios.post(`/api/usuarios-trs/${id}/foto`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
